module.exports = __webpack_public_path__ + "img/zhuanpan-bg3.11452c26.png";